import { Orientations, OrientationsNamesByGroupIds } from '@/enums/products'

export default function ({ route, error }) {
  const socks = OrientationsNamesByGroupIds[21].toLowerCase()

  if (
    (route.params.landing !== Orientations.menoriginals && route.params.orientation !== Orientations.menoriginals) &&
    (route.params.landing !== Orientations.menone && route.params.orientation !== Orientations.menone) &&
    (route.params.landing !== Orientations.boysoriginals && route.params.orientation !== Orientations.boysoriginals) &&
    (route.params.landing !== socks && route.params.orientation !== Orientations.socksoriginals)
  ) {
    return error('Page not found', 404)
  }
}
